export default {
  computed: {
    siteId() {
      const indexId = parseInt(this.$route.params?.indexId, 10) || 0;
      return indexId;
    },
    indexId() {
      return this.siteId;
    },
  },
};
